import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material';

const theme = createTheme({
  palette: {
    primary: {
      light: '#eff0ff',
      main: '#1976D2',
      dark: '#1565C0',
      contrastText: '#fff',
    },
    secondary: {
      light: '#ff7961',
      main: '#f44336',
      dark: '#ba000d',
      contrastText: '#000',
    },
  },
  typography: {
    fontSize: 14,
    fontFamily: "'Rubik', sans-serif",
    h1: {
      fontFamily: "'Rubik', sans-serif",
      fontWeight: 600,
    },
    h2: {
      fontFamily: "'Rubik', sans-serif",
      fontWeight: 600,
    },
    h3: {
      fontFamily: "'Rubik', sans-serif",
      fontWeight: 600,
    },
    h4: {
      fontFamily: "'Rubik', sans-serif",
      fontWeight: 600,
    },
    h5: {
      fontFamily: "'Rubik', sans-serif",
      fontWeight: 500,
    },
    h6: {
      fontFamily: "'Rubik', sans-serif",
      fontWeight: 500,
    },
    button: {
      fontFamily: "'Rubik', sans-serif",
      fontWeight: 500,
      textTransform: 'none',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        '@global': {
          '*': {
            fontFamily: "'Rubik', sans-serif",
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontFamily: "'Rubik', sans-serif",
          fontWeight: 500,
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          fontFamily: "'Rubik', sans-serif",
          fontWeight: 500,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          fontFamily: "'Rubik', sans-serif",
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          fontFamily: "'Rubik', sans-serif",
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontFamily: "'Rubik', sans-serif",
        },
      },
    },
  },
});

function ThemeMuiProvider({ children }) {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}

export default ThemeMuiProvider;
